import styled from 'styled-components'

export const FlexContainer = styled.div`
  position: relative;
  display: flex;
  flex-flow: wrap;
  justify-content: center;
  align-items: center;
  width: 100%;
  min-height: 100vh;
  padding: 50px 15px;
`

export const ColLeft = styled.div`
  width: 50%;
  display: flex;
  justify-content: flex-end;

  @media (max-width: 1050px) {
    width: 100%;
    justify-content: center;
    order: 2;
  }
`

export const ColRight = styled.div`
  width: 50%;
  display: flex;
  justify-content: flex-start;

  @media (max-width: 1050px) {
    width: 100%;
    justify-content: center;
    order: 1;
  }
`
